import { render } from "./FooterEditorView.vue?vue&type=template&id=f4f85340"
import script from "./FooterEditorView.vue?vue&type=script&lang=js"
export * from "./FooterEditorView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__